import type { FeatureCohort } from "../types";
import { FeatureCohortsPage } from "./FeatureCohortsPage";

export const featureCohorts = {
  list: FeatureCohortsPage,
  recordRepresentation: (record: FeatureCohort) =>
    record?.name ?? record?.slug ?? "Feature cohort",
};

export default featureCohorts;
